import SearchResult from './SearchResult';
import type { SearchResultProps } from './SearchResult';

export default SearchResult;
export type { SearchResultProps };
